import { useCallback } from "react";
import { Icons, TriggerButton } from "widgets";

import { getUrls } from "../../../api/openapi.ts";
import { TrackEnum } from "../../../openapi.ts";
import { useGenomeViewerStore } from "../../../store/store.ts";
import { routeWithBasename } from "../../../utils/route-with-basename.ts";
import { getEntityTypeFromTrackType } from "../../../utils/type-conversion.ts";

export const OpenGenomeViewerButton = ({
  id,
  trackId,
  proteinId,
}: {
  id: number;
  trackId: string;
  proteinId?: number;
}) => {
  const trackType = useGenomeViewerStore((state) => state.tracks.get(trackId)?.trackType);

  const handleClick = useCallback(() => {
    if (!trackType || (trackType === TrackEnum.PROTEIN_LOCATION && !proteinId)) return;
    const type = getEntityTypeFromTrackType(trackType);
    window.open(
      routeWithBasename(`/${type}/${trackType === TrackEnum.PROTEIN_LOCATION ? proteinId : id}/genome`, getUrls()),
      "_blank",
    );
  }, [id, proteinId, trackType]);

  return (
    <TriggerButton
      icon={<img src={Icons.Action.GenomeViewer} width={20} height={20} alt="Genome Viewer" />}
      onPress={handleClick}
      label={"Open in Genome Viewer"}
      isDisabled={trackType === TrackEnum.SEQUENCE}
    />
  );
};
